export const nitrileGlovesFormFields = [
    { 
        name: 'name', 
        type: 'text' as const, 
        placeholder: 'Full Name',
        required: true
    },
    { 
        name: 'email', 
        type: 'email' as const, 
        placeholder: 'Work Email',
        required: true
    },
    { 
        name: 'phone', 
        type: 'tel' as const, 
        placeholder: 'Phone',
        required: true
    },
    { 
        name: 'company', 
        type: 'text' as const, 
        placeholder: 'Company Name',
        required: true
    },
    { 
        name: 'category', 
        type: 'select' as const, 
        placeholder: 'Type',
        options: [
            { value: 'Medical Exam', label: 'Medical Exam' },
            { value: 'Chemo-Rated', label: 'Chemo-Rated' },
            { value: 'Non-Medical', label: 'Non-Medical' },
            { value: 'Food Grade', label: 'Food Grade' },
            { value: 'Not Sure', label: 'Not Sure' }
        ]
    },
    { 
        name: 'product', 
        type: 'select' as const, 
        placeholder: 'Thickness',
        options: [
            { value: '4 mil', label: '4 mil' },
            { value: '5 mil', label: '5 mil' },
            { value: '6 mil', label: '6 mil' },
            { value: 'Other', label: 'Other' }
        ]
    },
    { 
        name: 'quantity', 
        type: 'select' as const, 
        placeholder: 'Quantity',
        options: [
            { value: '10 Boxes (minimum)', label: '10 Boxes (minimum)' },
            { value: '30', label: '30' },
            { value: '50', label: '50' },
            { value: '100', label: '100' },
            { value: '500', label: '500' },
            { value: 'Over 1,000+', label: 'Over 1,000+' },
            { value: 'Other Quantity Not Listed', label: 'Other Quantity Not Listed' }
        ]
    }
]; 